window.onload = function(){
  if(BSS_B2B) {
    setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)
  BSS_B2B.customTriggerCheckoutBtn = function(){
    window.location.href = '/checkout'
}
    
    const loop = setInterval(() => {
      if($(".bss-b2b-rf-submit-button").length) {
        document.querySelector(".bss-b2b-rf-submit-button .btn").outerHTML = `<button type="submit" value="submit" class="btn"><span>Submit</span></button>`;
        $("#bss-b2b-registration-form").before($(".bss-b2b-registration-form-title"))
        clearInterval(loop);
      }
    })
    
    setTimeout(() => {
      clearInterval(loop);
    }, 10000)
  
    document.addEventListener("BSS:filterCollection", e => {
      setTimeout(() => {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,0,0);
      }, 300)
    });
    document.addEventListener("BSS:openCartDrawer", e => {
      setTimeout(() => {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,0,0);
        BSS_B2B.cart.fixer(BSS_B2B.shopData,0,0)
        BSS_B2B.handleCartcheckoutBtn(BSS_B2B.shopData)
      }, 1000)
      setTimeout(() => {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,0,0);
      }, 3000)
    });

    const isCartPage = window.location.pathname === '/cart';
    if(isCartPage) {
      const loop = setInterval(() => {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,0,0);
      }, 1500)

      setTimeout(() => {
        clearInterval(loop);
      }, 20000)
    }
  }
}
